import React, { InputHTMLAttributes, useEffect, useRef } from 'react';
import Icon, { IIconType } from '../Icon';

import { Container, Label } from './styles';

interface IInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  padding?: string;
  innerPadding?: string;
  margin?: string;
  onlyWhite?: boolean;
  autoFocus?: boolean;
  icon?: IIconType;
  min?: string;
  defaultValue?: string;
}

const Input: React.FC<IInputProps> = ({label, defaultValue, padding, innerPadding, margin, onlyWhite, autoFocus, icon, ...rest}) => {

  const inputEl = useRef<HTMLInputElement>(null);

  useEffect(() => {
    autoFocus && inputEl.current?.focus();
  }, [autoFocus])

  return (
    <Container padding={padding} margin={margin} innerPadding={innerPadding} onlyWhite={onlyWhite}>
      {icon && <Icon icon={icon} />}
      <input {...rest} defaultValue={defaultValue} autoComplete="off" ref={inputEl} />
      <Label onlyWhite={onlyWhite}>{label}</Label>
    </Container>
  );
}

export default Input;
